import { render, staticRenderFns } from "./AuthRegisterCompany.vue?vue&type=template&id=ec4f195c&scoped=true&"
import script from "./AuthRegisterCompany.vue?vue&type=script&lang=js&"
export * from "./AuthRegisterCompany.vue?vue&type=script&lang=js&"
import style0 from "./AuthRegisterCompany.vue?vue&type=style&index=0&id=ec4f195c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4f195c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VCombobox,VForm,VIcon,VRow,VTextField})
